import { ChatThread } from '../models/chat.interface';

export function normalizeChatThread(thread: ChatThread): ChatThread {
  return {
    ...thread,
    lastSentAt: thread.lastSentAt ? new Date(thread.lastSentAt) : null,
    deletedAt: thread.deletedAt ? new Date(thread.deletedAt) : null,
    updatedAt: new Date(thread.updatedAt),
    createdAt: new Date(thread.createdAt),
  };
}
